<template>
  <div class="container-fluid" v-if="tapRequestId && currentTabState">
    <PageHeader
      :page="page"
      :has-return="false"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <ActionButton
          text="Regresar"
          i="fas fa-arrow-circle-left fa-fw"
          variant="outline-success"
          class="m-1"
          @click="$router.go(-1)"
        />
        <ActionButton
          v-if="
            (!currentStatusTarget &&
              currentTabState.showActions.includes('save')) ||
              canEditRelatedService
          "
          text="Guardar"
          variant="success m-1"
          i="fas fa-save"
          :responsive="false"
          @click="onSave"
        />

        <ChangeOfStatusDropdown v-if="showChangeStatus" />

        <ActionButton
          v-if="currentTabState.showActions.includes('print')"
          text="Imprimir"
          :disabled="printDisabled"
          variant="success m-1"
          i="fas fa-print"
          :responsive="false"
          @click="print"
        />
      </template>
    </PageHeader>

    <div class="mb-3">
      <ChangeOfStatus
        :tap-request-id="tapRequestId"
        :tap-request-transfer-service-determination="transferServiceCode"
        :academic-year-id="academicYearId"
        @before-status-changed="beforeTapRequestStatusChanged"
        @after-status-changed="afterStatusChanged"
      />
    </div>

    <Board v-if="studentDetails" :details="studentDetails" />

    <div class="mt-3">
      <b-tabs
        v-if="ready"
        :value="tab_proxy"
        content-class="mt-3"
        nav-class="nav-vue-underline"
        :no-nav-style="true"
        lazy
      >
        <b-tab
          lazy
          :key="`tab_${enums.tabs['Analisis Escuela']}`"
          title="Análisis Inicial"
          @click="tab_proxy = enums.tabs['Analisis Escuela']"
        >
          <UbicationTechAssistanceWrapper
            :model-data="requestModelData"
            :show-services-summary="canViewServicesSummary"
            :services-summary="servicesSummaryForDisplay"
            :services-summary-collections="servicesSummaryCollections"
            readonly
          />
        </b-tab>

        <b-tab
          lazy
          v-if="
            !isInQuerella &&
              tabsState.showTabs.includes(
                enums.tabs['Analisis Facilitador Docente']
              ) &&
              tabsState.tabs[enums.tabs['Analisis Facilitador Docente']].visible
          "
          :key="`tab_${enums.tabs['Analisis Facilitador Docente']}`"
          title="Análisis del Facilitador Docente"
          @click="tab_proxy = enums.tabs['Analisis Facilitador Docente']"
        >
          <ValidationObserver
            :ref="`Tab_${enums.tabs['Analisis Facilitador Docente']}_Observer`"
          >
            <FacilitatorAnalysis
              ref="facilitatorComp"
              :show-services-summary="canViewServicesSummary"
              :services-summary="servicesSummaryForDisplay"
              :services-summary-collections="servicesSummaryCollections"
              :model-to-save.sync="FacilitatorSaveDTO"
              :readonly="
                tabsState.tabs[enums.tabs['Analisis Facilitador Docente']]
                  .readonly
              "
              :validate="
                currentStatusTarget
                  ? tabsState.tabs[
                      enums.tabs['Analisis Facilitador Docente']
                    ].statusTargetValidate.includes(currentStatusTarget.id)
                  : false
              "
              :sections-states.sync="
                tabsState.tabs[enums.tabs['Analisis Facilitador Docente']]
                  .sections
              "
            >
              <template #Observations>
                <Observations
                  ref="observations"
                  :sie="studentSieId"
                  :can-remove="canRemoveObservation"
                  :tab-id="enums.tabs['Analisis Facilitador Docente']"
                  :tap-request-id="tapRequestId"
                  :readonly="
                    tabsState.tabs[enums.tabs['Analisis Facilitador Docente']]
                      .readonly
                  "
                  @onObservationAdded="onObservationAdded"
                  @onObservationRemove="onObservationRemove"
                />
              </template>
            </FacilitatorAnalysis>
          </ValidationObserver>
        </b-tab>
        <b-tab v-else title-item-class="d-none" />

        <b-tab
          lazy
          v-if="
            !isInQuerella &&
              tabsState.showTabs.includes(
                enums.tabs['Consulta Director CSEE']
              ) &&
              tabsState.tabs[enums.tabs['Consulta Director CSEE']].visible
          "
          :key="`tab_${enums.tabs['Consulta Director CSEE']}`"
          title="Análisis del CSEE"
          @click="tab_proxy = enums.tabs['Consulta Director CSEE']"
        >
          <ValidationObserver
            :ref="`Tab_${enums.tabs['Consulta Director CSEE']}_Observer`"
          >
            <CSEEAnalysis
              ref="directorComp"
              :show-services-summary="canViewServicesSummary"
              :services-summary="servicesSummaryForDisplay"
              :services-summary-collections="servicesSummaryCollections"
              :readonly="
                tabsState.tabs[enums.tabs['Consulta Director CSEE']].readonly
              "
              :validate="
                currentStatusTarget
                  ? tabsState.tabs[
                      enums.tabs['Consulta Director CSEE']
                    ].statusTargetValidate.includes(currentStatusTarget.id)
                  : false
              "
              :model-to-save.sync="CSEEAnalysisSaveDTO"
              :sections-states.sync="
                tabsState.tabs[enums.tabs['Consulta Director CSEE']].sections
              "
            >
              <template #Observations>
                <Observations
                  ref="observations"
                  :sie="studentSieId"
                  :can-remove="canRemoveObservation"
                  :tab-id="enums.tabs['Consulta Director CSEE']"
                  :tap-request-id="tapRequestId"
                  :readonly="
                    tabsState.tabs[enums.tabs['Consulta Director CSEE']]
                      .readonly
                  "
                  @onObservationAdded="onObservationAdded"
                  @onObservationRemove="onObservationRemove"
                />
              </template>
            </CSEEAnalysis>
          </ValidationObserver>
        </b-tab>
        <b-tab v-else title-item-class="d-none" />

        <b-tab
          lazy
          v-if="
            tabsState.showTabs.includes(enums.tabs['Analisis Nivel Central']) &&
              tabsState.tabs[enums.tabs['Analisis Nivel Central']].visible
          "
          :key="`tab_${enums.tabs['Analisis Nivel Central']}`"
          title="Análisis de Nivel Central"
          @click="tab_proxy = enums.tabs['Analisis Nivel Central']"
        >
          <ValidationObserver
            :ref="`Tab_${enums.tabs['Analisis Nivel Central']}_Observer`"
          >
            <CentralLevelAnalysis
              ref="centralLevelComp"
              :request-type-id="requestModelData.requestType"
              :model-to-save.sync="CentralLevelAnalysisSaveDTO"
              :readonly="
                tabsState.tabs[enums.tabs['Analisis Nivel Central']].readonly
              "
              :validate-service-sumarry="isTargetStatus"
              :need-to-validate="
                currentStatusTarget
                  ? tabsState.tabs[
                      enums.tabs['Analisis Nivel Central']
                    ].statusTargetValidate.includes(currentStatusTarget.id)
                  : false
              "
              :sections-states.sync="
                tabsState.tabs[enums.tabs['Analisis Nivel Central']].sections
              "
              :is-amendment="isAmendment"
              :student="student"
              :statusId="currentStatusId"
            >
              <template #Observations>
                <Observations
                  ref="observations"
                  :sie="studentSieId"
                  :can-remove="canRemoveObservation"
                  :tab-id="enums.tabs['Analisis Nivel Central']"
                  :tap-request-id="tapRequestId"
                  :readonly="
                    tabsState.tabs[enums.tabs['Analisis Nivel Central']]
                      .readonly
                  "
                  @onObservationAdded="onObservationAdded"
                  @onObservationRemove="onObservationRemove"
                />
              </template>
            </CentralLevelAnalysis>
          </ValidationObserver>
        </b-tab>
        <b-tab v-else title-item-class="d-none" />

        <b-tab
          lazy
          v-if="
            tabsState.showTabs.includes(enums.tabs['Analisis del SAEE']) &&
              tabsState.tabs[enums.tabs['Analisis del SAEE']].visible
          "
          :key="`tab_${enums.tabs['Analisis del SAEE']}`"
          title="Análisis del(la) Secretario(a)"
          @click="tab_proxy = enums.tabs['Analisis del SAEE']"
        >
          <ValidationObserver
            :ref="`Tab_${enums.tabs['Analisis del SAEE']}_Observer`"
          >
            <SAEEAnalysis
              ref="SaeeComp"
              :show-services-summary="canViewServicesSummary"
              :services-summary="servicesSummaryForDisplay"
              :services-summary-collections="servicesSummaryCollections"
              :model-to-save.sync="SAEESaveDTO"
              :readonly="
                tabsState.tabs[enums.tabs['Analisis del SAEE']].readonly
              "
              :validate="
                currentStatusTarget
                  ? tabsState.tabs[
                      enums.tabs['Analisis del SAEE']
                    ].statusTargetValidate.includes(currentStatusTarget.id)
                  : false
              "
              :sections-states.sync="
                tabsState.tabs[enums.tabs['Analisis del SAEE']].sections
              "
            >
              <template #Observations>
                <Observations
                  ref="observations"
                  :sie="studentSieId"
                  :can-remove="canRemoveObservation"
                  :tab-id="enums.tabs['Analisis del SAEE']"
                  :tap-request-id="tapRequestId"
                  :readonly="
                    tabsState.tabs[enums.tabs['Analisis del SAEE']].readonly
                  "
                  @onObservationAdded="onObservationAdded"
                  @onObservationRemove="onObservationRemove"
                />
              </template>
            </SAEEAnalysis>
          </ValidationObserver>
        </b-tab>
        <b-tab v-else title-item-class="d-none" />

        <b-tab
          lazy
          v-if="isAmendment"
          title="Historial de Enmiendas"
          :key="`tab_${enums.tabs['Historial de Enmiendas']}`"
          @click="tab_proxy = enums.tabs['Historial de Enmiendas']"
        >
          <AmendmentHistory />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import studentApi from '@/services/student.js';
import Board from 'Board';
import {
  ChangeOfStatus,
  ChangeOfStatusDropdown,
} from '@/components/pei/ubication-tech-assistance/_components';
import UbicationTechAssistanceWrapper from './_components/UbicationTechAssistanceWrapper';
import FacilitatorAnalysis from './_components/FacilitatorAnalysis';
import CSEEAnalysis from './_components/CSEEAnalysis';
import CentralLevelAnalysis from './_components/CentralLevelAnalysis';
import SAEEAnalysis from './_components/SAEEAnalysis';
import AmendmentHistory from './_components/AmendmentHistory/Index.vue';
import alert from '@/mixin/alert.mixin';
import {
  tapRequestTypesEnum,
  tapRequestStatusesEnum,
} from '@/components/pei/ubication-tech-assistance/_types';
import { serviceEnum } from '@/components/pei/ubication-tech-assistance/management/_types';
import objectToFormData from 'object-to-formdata';
import {
  saveFacilitatorTab,
  saveCSEEAnalysis,
  saveCentralLevelAnalysis,
  saveSAEEAnalysis,
  saveObservation,
  removeObservation,
} from '@/components/pei/ubication-tech-assistance/_api';
import ActionButton from 'ActionButton';
import { UTA_MANAGEMENT_TABS_ENUM } from '@/components/pei/ubication-tech-assistance/_config/management';
import { mapState, mapGetters, mapActions } from 'vuex';
import {
  statusManagementStore,
  registerStatusManagementStore,
  unregisterStatusManagementStore,
} from '@/components/pei/ubication-tech-assistance/_store';
import {
  getTapRequest,
  getCentralLevelServices,
  getTherapyservicesfilters,
} from '@/services/api/tapRequest.api.js';
import Observations from '@/components/pei/ubication-tech-assistance/management/_components/Observations';
import { UTA_MANAGEMENT_REQUEST_TYPE } from '@/components/pei/ubication-tech-assistance/_config/management';
import { servicesEnum } from '../_components/ServicesProvided/_types';
import { TapRequestStatus } from '@/components/student/search/StudentMessage.vue';
import store from '@/store/index';

export default {
  name: 'Management',
  mixins: [alert],
  provide() {
    return {
      tapRequestId: this.tapRequestId,
    };
  },
  components: {
    PageHeader,
    Board,
    UbicationTechAssistanceWrapper,
    FacilitatorAnalysis,
    CSEEAnalysis,
    CentralLevelAnalysis,
    SAEEAnalysis,
    ChangeOfStatus,
    ChangeOfStatusDropdown,
    ActionButton,
    Observations,
    AmendmentHistory,
  },
  props: {
    tapRequestId: { type: [Number, String], required: true, default: null },
  },
  data() {
    return {
      enums: { tabs: UTA_MANAGEMENT_TABS_ENUM },
      page: {
        icon: 'fas fa-user-edit',
        title:
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        routes: [
          'Inicio',
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        ],
      },
      studentSieId: null,
      academicYearId: 0,
      student: null,
      selectedOption: null,
      FacilitatorSaveDTO: {},
      CSEEAnalysisSaveDTO: {},
      CentralLevelAnalysisSaveDTO: {
        alternativeLocation: {},
      },
      printDisabled: false,
      SAEESaveDTO: {},
      ready: false,
      requestModelData: null,
      servicesSummaryCatalogs: {
        services: [],
        frequencies: [],
        modalities: [],
        durations: [],
      },
    };
  },
  computed: {
    ...mapState(statusManagementStore, [
      'currentTab',
      'currentStatus',
      'currentStatusTarget',
      'statusTargets',
      'tabsState',
    ]),
    ...mapGetters(statusManagementStore, ['currentTabState']),
    currentStatusId() {
      return this.currentStatus?.id ?? null;
    },
    canEditRelatedService() {
      let canEdit = false;

      const hasEditPermission = this.$store.getters.HasPermission(
        'academic.pei.ubicationtechassistance.edit.relatedservices.onprocessamendment'
      );
      const isAtCentralLevelAnalysisTab =
        this.currentTab == this.enums.tabs['Analisis Nivel Central'];
      if (
        this.currentStatusId ===
          tapRequestStatusesEnum['Proceso de Enmienda'] &&
        hasEditPermission &&
        isAtCentralLevelAnalysisTab
      ) {
        canEdit = true;
      }

      return canEdit;
    },
    tab_proxy: {
      get() {
        return this.currentTab;
      },
      set(value) {
        this.setCurrentTab(value);
      },
    },
    isTargetStatus() {
      return (
        this.currentStatusTarget?.id !=
        tapRequestStatusesEnum['Devuelto al Director de CSEE']
      );
    },
    isInQuerella() {
      return (
        this.requestModelData.requestType ===
        UTA_MANAGEMENT_REQUEST_TYPE.QUERELLA
      );
    },
    canViewServicesSummary() {
      return (
        this.requestModelData &&
        this.currentStatusId !== tapRequestStatusesEnum['Nuevo'] &&
        this.requestModelData.requestType ===
          UTA_MANAGEMENT_REQUEST_TYPE.RENOVACION
      );
    },
    servicesSummaryForDisplay() {
      const servicesSummary = this.requestModelData?.servicesSummary ?? [];
      return servicesSummary.map((serviceSum) => ({
        ...serviceSum,
        therapyServiceModality: this.servicesSummaryCollections.modalities.find(
          (x) => x.id == serviceSum.therapyServiceModalityId
        ),
        therapyFrequency: this.servicesSummaryCollections.frequencies.find(
          (x) => x.id == serviceSum.therapyFrequencyId
        ),
        therapyDuration: this.servicesSummaryCollections.durations.find(
          (x) => x.id == serviceSum.therapyDurationId
        ),
        itinerantService: this.servicesSummaryCollections.itinerantServices.find(
          (x) => x.id == serviceSum.itinerantService
        ),
      }));
    },
    servicesSummaryCollections() {
      return {
        services: this.servicesSummaryCatalogs.services,
        servicesPreviousYear:
          this.requestModelData?.servicesSummaryPreviousYear ?? [],
        itinerantServices: [
          { id: true, name: 'Si' },
          { id: false, name: 'No' },
        ],
        frequencies: this.servicesSummaryCatalogs.frequencies,
        modalities: this.servicesSummaryCatalogs.modalities,
        durations: this.servicesSummaryCatalogs.durations,
      };
    },
    isNoVigenteBaja() {
      return this.currentStatus?.id === tapRequestStatusesEnum['NoVigenteBaja'];
    },
    studentDetails() {
      if (!this.student) return;
      return [
        [
          {
            label: 'Estudiante',
            data: this.student.fullName,
            icon: 'fas fa-address-book',
          },
          {
            label: 'Número de Consulta',
            data: this.requestModelData.businessId,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Estatus',
            data: this.currentStatus.name,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Escuela',
            data: `${this.student.schoolCode} - ${this.student.schoolName}`,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Impedimento',
            data: this.student.impediment,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
    hasAmendment() {
      return this.requestModelData && this.requestModelData.amendmentId;
    },
    showChangeStatus() {
      return !this.isNoVigenteBaja && !this.hasAmendment;
    },
    isAmendment() {
      return this.requestModelData && this.requestModelData.isAmendment;
    },
    transferServiceCode() {
      return this.CentralLevelAnalysisSaveDTO?.transfer?.institutionServiceCode;
    },
    canRemoveObservation() {
      return store.getters.HasPermission(
        'ubication.tech.assistance.remove.observation'
      );
    },
  },
  methods: {
    ...mapActions(statusManagementStore, [
      'setCurrentMode',
      'setCurrentStatus',
      'setCurrentTab',
      'setStatusTargets',
      'setApprovalNotifiedInfo',
      'setCurrentRequestTypeId',
    ]),
    async refreshObservations() {
      // refresh observations after modify one.
      const observationRef = this.$refs?.observations;
      if (observationRef) {
        await observationRef?.loadObservations();
      }
    },
    async onObservationAdded(reason) {
      const payload = { comment: reason, typeId: this.currentTab };
      const response = await saveObservation(this.tapRequestId, payload);
      if (response) {
        const msjObj = {
          title: 'Confirmación',
          message: 'La observación ha sido añadida exitosamente.',
          type: 'success',
        };
        this.ShowToast(msjObj.title, msjObj.message, msjObj.type);

        await this.refreshObservations();
      }
    },
    async onObservationRemove(id) {
      try {
        await removeObservation(id);
        this.ShowToast('', 'Observación eliminada exitosamente', 'success');
      } catch {
        this.ShowToast(
          '',
          'Ocurrió un error al intentar eliminar la observación',
          'error'
        );
      }

      await this.refreshObservations();
    },
    async getStudent(sie) {
      const { data } = await studentApi.getBySie(sie);
      this.student = data;
    },
    async loadServicesSummaryCatalogs() {
      const [services, therapyFilters] = await Promise.all([
        getCentralLevelServices(),
        getTherapyservicesfilters(),
      ]);
      this.servicesSummaryCatalogs.services = services;
      this.servicesSummaryCatalogs.frequencies = therapyFilters.frequencies;
      this.servicesSummaryCatalogs.modalities = therapyFilters.modalities;
      this.servicesSummaryCatalogs.durations = therapyFilters.durations;
    },
    async beforeTapRequestStatusChanged() {
      if (
        this.currentTabState?.statusTargetValidate?.includes(
          this.currentStatusTarget?.id
        ) ||
        false
      ) {
        const currentTabObserver = this.$refs[
          `Tab_${this.currentTab}_Observer`
        ];
        currentTabObserver?.reset();
        const valid = await currentTabObserver?.validate();
        if (!valid) {
          const errors = currentTabObserver?.errors;
          if (errors && typeof errors === 'object') {
            console.warn('Campos con error (por vid/name):', errors);
          } else if (currentTabObserver?.$children?.length) {
            const fieldsWithErrors = [];
            currentTabObserver.$children.forEach((child) => {
              if (child.errors?.length > 0) {
                fieldsWithErrors.push({
                  name: child.name || child.vid,
                  errors: child.errors,
                });
              }
            });
            if (fieldsWithErrors.length) {
              console.warn('Campos con error:', fieldsWithErrors);
            }
          }
          this.ShowToast(
            'Información Incompleta',
            'Favor de completar la información solicitada.',
            'error'
          );
          return false;
        }
        // save the tab before status change
        if (
          this.currentTab == this.enums.tabs['Analisis Facilitador Docente']
        ) {
          await this.saveFacilitator(false);
        }
        if (this.currentTab == this.enums.tabs['Consulta Director CSEE']) {
          await this.saveCSEEAnalysis();
        }
        if (this.currentTab == this.enums.tabs['Analisis Nivel Central']) {
          return await this.saveCentralLevelAnalysis(
            this.currentStatusTarget?.id
          );
        }
        if (this.currentTab == this.enums.tabs['Analisis del SAEE']) {
          await this.saveSAEE();
        }
      }
      return true;
    },
    onReturn() {
      this.$router.push({ name: 'uta-search' });
    },
    async saveFacilitator(showToast = true) {
      if (this.FacilitatorSaveDTO.referredToDirector) {
        if (
          this.currentStatus?.id ===
          tapRequestStatusesEnum['Proceso de Consulta']
        ) {
          const confirmReferToDirector = await this.ShowCancelModal(
            'Confirmación',
            `¿Está seguro que desea cambiar el estatus de ${this.currentStatus?.name} a Recomendado a Evaluación de CSEE?`,
            'Sí',
            'No'
          );
          if (!confirmReferToDirector) {
            return;
          }
        }

        const isValid = await this.$refs[
          `Tab_${this.enums.tabs['Analisis Facilitador Docente']}_Observer`
        ].validate();
        if (!isValid) {
          this.ShowToast(
            'Información Incompleta',
            'Favor de completar la información solicitada.',
            'error'
          );
          return;
        }
      } else {
        this.$refs[
          `Tab_${this.enums.tabs['Analisis Facilitador Docente']}_Observer`
        ]?.reset();
      }

      const facilitatorDTO = {
        CSEEDirectorConsult: this.FacilitatorSaveDTO.cseeDirectorConsult,
        QuestionnaireAnswers: this.FacilitatorSaveDTO.compuRecommendations,
        Inquiries: this.FacilitatorSaveDTO.inquiries.map((c) => {
          return {
            PersonWhoAttends: c.personWhoAttends,
            RequestId: this.FacilitatorSaveDTO.id,
            DateReceived: c.dateReceived,
            DateAttended: c.dateAttended,
            TypeId: tapRequestTypesEnum.FacilitatorAnalysis,
          };
        }),
        StaffMembers: this.FacilitatorSaveDTO.requesters.map((r) => {
          return {
            RequestId: this.FacilitatorSaveDTO.id,
            FullName: r.name,
            RolId: r.role.id,
            Rol: r.role.name,
            TelephoneNumber: r.phone,
            Email: r.email,
            Signed: r.signed,
            TypeId: tapRequestTypesEnum.FacilitatorAnalysis,
          };
        }),
        document: this.FacilitatorSaveDTO.document,
        id: this.FacilitatorSaveDTO.id,
      };

      const data = objectToFormData(facilitatorDTO, { indices: true });

      let index = 0;
      let indexFile = 0;

      facilitatorDTO.document.data.files.forEach((element) => {
        if (!element.id) {
          data.append(`documents[${index}].file`, element.file, element.name);
          data.append(
            `documents[${index}].documentTypeId`,
            element.documentTypeId
          );
          index++;
        }
        indexFile++;
      });
      const request = await saveFacilitatorTab(facilitatorDTO.id, data);

      if (request) {
        const { documents } = request;

        this.$refs.facilitatorComp.model.documents = documents;
        this.$refs.facilitatorComp.fillDocuments();

        if (this.FacilitatorSaveDTO.referredToDirector) {
          const {
            status: { id: statusId, name: statusName },
            statusReasons,
            returnReason,
            availableStates,
          } = request;

          this.setCurrentStatus({
            id: statusId,
            name: statusName,
            reason: returnReason,
            reasonTypes: [...statusReasons],
          });
          this.setStatusTargets(availableStates);
        }
      }

      if (request && showToast) {
        this.showConfirmation();
      }
    },
    async saveCSEEAnalysis() {
      const cseeDTO = {
        id: this.CSEEAnalysisSaveDTO.id,
        QuestionnaireAnswers: this.CSEEAnalysisSaveDTO.compuRecommendations,
        Inquiries: this.CSEEAnalysisSaveDTO.inquiries.map((c) => {
          return {
            PersonWhoAttends: c.personWhoAttends,
            RequestId: this.CSEEAnalysisSaveDTO.id,
            DateReceived: c.dateReceived,
            DateAttended: c.dateAttended,
            TypeId: tapRequestTypesEnum.DirectorAnalysis,
          };
        }),
        StaffMembers: this.CSEEAnalysisSaveDTO.requesters.map((r) => {
          return {
            RequestId: this.CSEEAnalysisSaveDTO.id,
            FullName: r.name,
            RolId: r.role.id,
            Rol: r.role.name,
            TelephoneNumber: r.phone,
            Email: r.email,
            Signed: r.signed,
            TypeId: tapRequestTypesEnum.DirectorAnalysis,
          };
        }),
        analyzerCSEE: {
          ...this.CSEEAnalysisSaveDTO.analyzerCSEE,
          LocationSchoolId:
            this.CSEEAnalysisSaveDTO.analyzerCSEE.locationSchool?.id || null,
          TapRequestId: this.CSEEAnalysisSaveDTO.analyzerCSEE.id,
        },
        document: this.CSEEAnalysisSaveDTO.document,
      };
      const data = objectToFormData(cseeDTO, { indices: true });

      let index = 0;
      let indexFile = 0;
      cseeDTO.document.data.files.forEach((element) => {
        if (!element.id) {
          data.append(`documents[${index}].file`, element.file, element.name);
          data.append(
            `documents[${index}].documentTypeId`,
            element.documentTypeId
          );
          index++;
        }
        indexFile++;
      });

      const request = await saveCSEEAnalysis(cseeDTO.id, data);

      if (request) {
        const { documents } = request;

        this.$refs.directorComp.model.documents = documents;
        this.$refs.directorComp.fillDocuments();

        const msjObj = {
          title: 'Confirmación',
          message: 'El análisis ha sido guardado exitosamente.',
          type: 'success',
        };
        this.ShowToast(msjObj.title, msjObj.message, msjObj.type);
      }
    },
    async saveCentralLevelAnalysis(statusId = 0) {
      const centralLevelAnalysisRef = this.$refs.centralLevelComp ?? {};
      const centralLevelDTO = {
        id: this.CentralLevelAnalysisSaveDTO.id,
        HasRetroactivePaymentAuthorization: this.CentralLevelAnalysisSaveDTO
          .hasRetroactivePaymentAuthorization,

        RetroactivePaymentJustification: this.CentralLevelAnalysisSaveDTO
          .retroactivePaymentJustification,

        RetroactivePaymentDocuments: this.CentralLevelAnalysisSaveDTO
          .retroactivePaymentDocuments,
        QuestionnaireAnswers: this.CentralLevelAnalysisSaveDTO
          .compuRecommendations,
        Inquiries: this.CentralLevelAnalysisSaveDTO.inquiries.map((c) => {
          return {
            PersonWhoAttends: c.personWhoAttends,
            RequestId: this.CentralLevelAnalysisSaveDTO.id,
            DateReceived: c.dateReceived,
            DateAttended: c.dateAttended,
            TypeId: tapRequestTypesEnum.CentralLevelAnalysis,
          };
        }),
        StaffMembers: this.CentralLevelAnalysisSaveDTO.requesters.map((r) => {
          return {
            RequestId: this.CentralLevelAnalysisSaveDTO.id,
            FullName: r.name,
            RolId: r.role.id,
            Rol: r.role.name,
            TelephoneNumber: r.phone,
            Email: r.email,
            Signed: r.signed,
            TypeId: tapRequestTypesEnum.CentralLevelAnalysis,
          };
        }),
        Transfer: {
          destinationLocationSchool:
            this.CentralLevelAnalysisSaveDTO.transfer.destinationLocationSchool
              ?.id || null,
          transferStartDate: null,
          institutionServiceCode: this.CentralLevelAnalysisSaveDTO.transfer
            .institutionServiceCode?.id,
          residence: this.CentralLevelAnalysisSaveDTO.transfer.residence?.id,
          comments: this.CentralLevelAnalysisSaveDTO.transfer.comments || null,
        },
        document: this.CentralLevelAnalysisSaveDTO.document,
        AlternativeLocation: {
          alternativeLocationCategoryId: this.CentralLevelAnalysisSaveDTO
            .alternativeLocation?.alternativeLocationCategory?.id,
          numberOfStudentsId: this.CentralLevelAnalysisSaveDTO
            .alternativeLocation?.numberOfStudents?.id,
          gradeId: this.CentralLevelAnalysisSaveDTO.alternativeLocation?.grade
            ?.id,
          comment: this.CentralLevelAnalysisSaveDTO.alternativeLocation
            ?.comment,
        },
        ServicesSummary: this.CentralLevelAnalysisSaveDTO.servicesSummary.map(
          (s) => {
            // Obtener nombre completo del usuario si hay comentario y es un servicio nuevo
            let commentCreatedBy = s.commentCreatedBy;
            if (s.comment && (s.id === 0 || !s.id) && !commentCreatedBy) {
              const userProfile = this.$store.getters['$_user/fullProfile'];
              if (userProfile) {
                commentCreatedBy = `${userProfile.firstname ||
                  ''} ${userProfile.lastpaternalname || ''}`.trim();
              }
            }

            return {
              Id: s.id || 0,
              RequestId: this.CentralLevelAnalysisSaveDTO.id,
              ServiceId: s.service.id,
              Frequency: s.frequency,
              Cost: s.cost,
              Other: s.other,
              itinerantService: s.itinerantService?.id || false,
              TherapyDurationId:
                s.therapyDuration?.id ??
                centralLevelAnalysisRef.relatedServices?.find(
                  (x) => x?.service?.id === s.service?.disciplineTypeId
                )?.duration?.id,
              TherapyFrequencyId: s.therapyFrequency?.id,
              TherapyServiceModalityId:
                s.therapyServiceModality?.id ??
                centralLevelAnalysisRef.relatedServices?.find(
                  (x) => x?.service?.id === s.service?.disciplineTypeId
                )?.modality?.id,
              CategoryId: s.service?.categoryId,
              DisciplineTypeId: s.service?.disciplineTypeId,
              Comment: s.comment,
              CommentCreatedAt: s.commentCreatedAt,
              CommentCreatedBy: commentCreatedBy,
            };
          }
        ),
      };

      if (
        statusId == tapRequestStatusesEnum['Recomendado al(la) Secretario(a)']
      ) {
        var hasService = centralLevelDTO.ServicesSummary.find(
          (x) => x.ServiceId == serviceEnum.MonthlyPayment
        );
        if (!hasService) {
          this.ShowToast(
            'Información Incompleta',
            'Favor agregar el costo de Mensualidad, de ser un estudiante becado en el costo deben colocar 0.',
            'error'
          );
          return false;
        }
      }

      if (
        statusId ===
          tapRequestStatusesEnum['Recomendado al(la) Secretario(a)'] &&
        centralLevelAnalysisRef.shouldShowRetroactivePayments
      ) {
        if (
          centralLevelDTO.HasRetroactivePaymentAuthorization === null ||
          centralLevelDTO.HasRetroactivePaymentAuthorization === undefined
        ) {
          this.ShowToast(
            'Información Incompleta',
            'Debe responder si la consulta tiene autorizados pagos retroactivos para continuar.',
            'error'
          );
          return false;
        }

        if (centralLevelDTO.HasRetroactivePaymentAuthorization === false) {
          this.ShowToast(
            'Información Incompleta',
            'Los meses ingresados sobrepasan la fecha límite del año escolar. No es posible avanzar sin autorización de pagos retroactivos.',
            'error'
          );
          return false;
        }

        if (centralLevelDTO.HasRetroactivePaymentAuthorization === false) {
          this.ShowToast(
            'Información Incompleta',
            'Los meses ingresados sobrepasan la fecha límite del año escolar. No es posible avanzar sin autorización de pagos retroactivos.',
            'error'
          );
          return false;
        }

        if (
          !centralLevelDTO.RetroactivePaymentJustification ||
          !centralLevelDTO.RetroactivePaymentJustification.trim()
        ) {
          this.ShowToast(
            'Información Incompleta',
            'Debe ingresar la justificación del pago retroactivo para continuar.',
            'error'
          );
          return false;
        }

        const hasDocuments =
          centralLevelDTO.RetroactivePaymentDocuments?.files?.length > 0;

        if (!hasDocuments) {
          this.ShowToast(
            'Información Incompleta',
            'Debe adjuntar al menos un documento que sustente el pago retroactivo para continuar.',
            'error'
          );
          return false;
        }
      }

      const data = objectToFormData(centralLevelDTO, { indices: true });

      let index = 0;
      let indexFile = 0;
      let retroIndex = 0;

      centralLevelDTO.RetroactivePaymentDocuments?.files?.forEach((element) => {
        if (!element.id) {
          data.append(
            `RetroactivePaymentDocuments[${retroIndex}].file`,
            element.file,
            element.name
          );

          data.append(
            `RetroactivePaymentDocuments[${retroIndex}].DocumentTypeId`,
            element.documentTypeId || element.documentType
          );

          retroIndex++;
        }
      });
      centralLevelDTO.document.data.files.forEach((element) => {
        if (!element.id) {
          data.append(`documents[${index}].file`, element.file, element.name);
          data.append(
            `documents[${index}].documentTypeId`,
            element.documentTypeId
          );
          index++;
        }
        indexFile++;
      });

      const request = await saveCentralLevelAnalysis(centralLevelDTO.id, data);

      // an error has occurred, return false
      if (!request) return false;

      if (request) {
        const { documents } = request;

        centralLevelAnalysisRef.model.documents = documents;
        centralLevelAnalysisRef.fillDocuments();
        centralLevelAnalysisRef.fillRetroactiveDocuments();

        const availableCatalogOptions =
          centralLevelAnalysisRef.availableCatalogOptions;
        centralLevelAnalysisRef.model.servicesSummary = request.servicesSummary.map(
          (item) => ({
            ...item,
            itinerantService: availableCatalogOptions.itinerantServices.find(
              (x) => x.id == item.itinerantService
            ),

            therapyServiceModality: availableCatalogOptions.modalities.find(
              (x) => x.id == item.therapyServiceModalityId
            ),
            therapyFrequency: availableCatalogOptions.frequencies.find(
              (x) => x.id == item.therapyFrequencyId
            ),
            therapyDuration: availableCatalogOptions.durations.find(
              (x) => x.id == item.therapyDurationId
            ),
          })
        );
        this.showConfirmation();
      }
      return true;
    },
    async saveSAEE() {
      const SAEEDTO = {
        id: this.SAEESaveDTO.id,
        DeterminationType: null,
        StaffMembers: this.SAEESaveDTO.requesters.map((r) => {
          return {
            RequestId: this.SAEESaveDTO.id,
            FullName: r.name,
            RolId: r.role.id,
            Rol: r.role.name,
            TelephoneNumber: r.phone,
            Email: r.email,
            Signed: r.signed,
            TypeId: tapRequestTypesEnum.SAEEAnalysis,
          };
        }),

        document: this.SAEESaveDTO.document,
      };
      const data = objectToFormData(SAEEDTO, { indices: true });

      let index = 0;
      let indexFile = 0;
      SAEEDTO.document.data.files.forEach((element) => {
        if (!element.id) {
          data.append(`documents[${index}].file`, element.file, element.name);
          data.append(
            `documents[${index}].documentTypeId`,
            element.documentTypeId
          );
          index++;
        }
        indexFile++;
      });

      const request = await saveSAEEAnalysis(SAEEDTO.id, data);
      if (request) {
        const { documents } = request;

        this.$refs.SaeeComp.model.documents = documents;
        this.$refs.SaeeComp.fillDocuments();

        this.showConfirmation();
      }
    },
    showConfirmation() {
      const msjObj = {
        title: 'Confirmación',
        message: 'El análisis ha sido guardado exitosamente.',
        type: 'success',
      };
      this.ShowToast(msjObj.title, msjObj.message, msjObj.type);
    },
    async onSave() {
      switch (this.currentTab) {
        case this.enums.tabs['Analisis Facilitador Docente']:
          await this.saveFacilitator();
          break;
        case this.enums.tabs['Consulta Director CSEE']:
          await this.saveCSEEAnalysis();
          break;
        case this.enums.tabs['Analisis Nivel Central']:
          await this.saveCentralLevelAnalysis();
          break;
        case this.enums.tabs['Analisis del SAEE']:
          await this.saveSAEE();
          break;
        default:
          break;
      }
    },
    async afterStatusChanged(data) {
      if (
        data.statusId == tapRequestStatusesEnum['Proceso de Enmienda'] &&
        data.amendmentId
      ) {
        const tapRequestId = data.amendmentId;

        this.$router.push({
          name: 'uta-management',
          params: { tapRequestId: tapRequestId },
        });

        return;
      }
    },
  },
  watch: {
    'currentStatusTarget.id'(value, oldValue) {
      if (value && value != oldValue) {
        this.$refs[`Tab_${this.currentTab}_Observer`]?.reset();
      }
    },
  },
  beforeCreate() {
    registerStatusManagementStore();
  },
  async created() {
    this.setCurrentMode('management');
    const { data } = await getTapRequest(this.tapRequestId);
    if (data) {
      this.requestModelData = data;
      const {
        studentSieId,
        academicYearId,
        statusId,
        statusName,
        statusReasons,
        returnReason,
        availableStates,
        approvalAcademicYear,
        approvalDetermination,
        studentInfo: studentFullName,
        schoolCode,
        schoolName,
        impediment,
      } = data;

      this.studentSieId = studentSieId;
      this.academicYearId = academicYearId;
      this.student = {
        studentId: studentSieId,
        fullName: studentFullName,
        schoolCode: schoolCode,
        schoolId: data?.schoolId,
        schoolName: schoolName,
        impediment: impediment,
      };

      this.setCurrentRequestTypeId(this.requestModelData.requestType);
      this.setCurrentStatus({
        id: statusId,
        name: statusName,
        reason: returnReason,
        reasonTypes: statusReasons || [],
      });
      this.setStatusTargets(availableStates);
      if (approvalAcademicYear && approvalDetermination) {
        this.setApprovalNotifiedInfo({
          academicYear: approvalAcademicYear,
          determination: approvalDetermination,
        });
      }
      if (this.canViewServicesSummary) {
        try {
          await this.loadServicesSummaryCatalogs();
        } catch (error) {
          // A catalog load failure must not blank the whole view: fall back to
          // empty catalogs and log the error for debugging (readonly summaries
          // will render '-' values in this case).
          console.error('Failed to load services summary catalogs:', error);
          this.servicesSummaryCatalogs.services = [];
          this.servicesSummaryCatalogs.frequencies = [];
          this.servicesSummaryCatalogs.modalities = [];
          this.servicesSummaryCatalogs.durations = [];
          this.ready = true;
        }
      }
      this.ready = true;
    }
  },
  watch: {
    'currentStatusTarget.id'(value, oldValue) {
      if (value && value != oldValue) {
        this.$refs[`Tab_${this.currentTab}_Observer`]?.reset();
      }
    },
    '$route.params.tapRequestId': {
      immediate: true,
      handler() {
        if (this.init) this.init();
      },
    },
  },
  destroyed() {
    unregisterStatusManagementStore();
  },
};
</script>
